import { AllowedImportField } from './allowed-import-fields';

export class ParsedImportData {
  headers: string[];
  allowed: AllowedImportField[];
  hash: string;
}
